<div class="container">
  <div class="row">
    <div class="col-12 col-lg-9 mb-8">
      <h1>{{ 'nousJoindre.titre' | translate }}</h1>
      <h2>{{ 'nousJoindre.titreQuestionCommentaire' | translate }}</h2>

      <p>
        {{ 'nousJoindre.questionCommentaire' | translate }}

        <a *ngIf="(courrielSupport$ | async) as courrielSupport" href="mailto: {{ courrielSupport }}">
          {{ 'nousJoindre.support' | translate }}
        </a>
      </p>
    </div>
  </div>
</div>

<zzz-piv-piedpage></zzz-piv-piedpage>
